import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import React from "react";
import {Component, ReactElement} from "react";
import ErrorPanel, {ErrorProps} from "../error";
import {DialogSize} from "./size";

export enum DialogButtonColor {
  primary = "primary",
  secondary = "secondary",
  default = "default",
}

export interface DialogButton {
  id: string;
  label: string;
  onClick: () => void;
  color?: DialogButtonColor;
  disabled?: boolean;
}

export interface GenericDialogProps {
  title: string;
  description: string;
  open: boolean;
  close: () => void;
  error?: ErrorProps;
  buttons: DialogButton[];
  size?: DialogSize;
  className?: string;
}

export function closedDialog(): GenericDialogProps {
  return {
    open: false,
    title: "",
    description: "",
    close: (): void => {
      return;
    },
    buttons: [],
  };
}

function getSizeClass(size?: DialogSize): string {
  return size ? size : DialogSize.normal;
}

function getClass(className?: string): string {
  return className ? ` ${className}` : "";
}

function getButtonsClassName(buttons: DialogButton[]): string {
  if (buttons.length > 1) {
    return "dialog-buttons";
  }
  if (buttons.length === 1) {
    return "dialog-single-button";
  }
  return "";
}

export default class GenericDialog extends Component<GenericDialogProps> {
  render(): ReactElement {
    const {
      open,
      close,
      title,
      description,
      error,
      size,
      buttons,
      children,
      className,
    } = this.props;

    return (
      <Dialog
        open={open}
        onClose={() => close()}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={
          "dialog generic-dialog " + getSizeClass(size) + getClass(className)
        }
      >
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          {description && <DialogContentText>{description}</DialogContentText>}
          {children}
          {error !== undefined && <ErrorPanel {...error} />}
        </DialogContent>
        {buttons.length ? (
          <DialogActions className={getButtonsClassName(buttons)}>
            {buttons.map((item) => (
              <Button
                key={item.id}
                onClick={() => item.onClick()}
                className={item.id}
                color={item.color}
                disabled={item.disabled}
              >
                {item.label}
              </Button>
            ))}
          </DialogActions>
        ) : (
          <React.Fragment></React.Fragment>
        )}
      </Dialog>
    );
  }
}
